import z from 'zod';
export var Payment_Terminal_Type;
(function (Payment_Terminal_Type) {
    Payment_Terminal_Type["STRIPE_S700"] = "STRIPE_S700";
    Payment_Terminal_Type["STRIPE_M2"] = "STRIPE_M2";
    Payment_Terminal_Type["STRIPE_VIRTUAL_TERMINAL"] = "STRIPE_VIRTUAL_TERMINAL";
    Payment_Terminal_Type["TILLED_A920_PRO"] = "TILLED_A920_PRO";
    Payment_Terminal_Type["PAX_A920_PRO"] = "PAX_A920_PRO";
    Payment_Terminal_Type["PAX_A77"] = "PAX_A77";
    Payment_Terminal_Type["BLOCKCHYP_LUXE_8500i"] = "BLOCKCHYP_LUXE_8500i";
    Payment_Terminal_Type["BLOCKCHYP_LUXE_6200m"] = "BLOCKCHYP_LUXE_6200m";
    Payment_Terminal_Type["GENERIC_TERMINAL"] = "GENERIC_TERMINAL";
})(Payment_Terminal_Type || (Payment_Terminal_Type = {}));
export var All_Payment_Terminals_Status;
(function (All_Payment_Terminals_Status) {
    All_Payment_Terminals_Status["PENDING_ACTIVATION"] = "PENDING_ACTIVATION";
    All_Payment_Terminals_Status["ACTIVE"] = "ACTIVE";
    All_Payment_Terminals_Status["INACTIVE"] = "INACTIVE";
    All_Payment_Terminals_Status["ACTIVATION_ERROR"] = "ACTIVATION_ERROR";
    All_Payment_Terminals_Status["FAILED"] = "FAILED";
})(All_Payment_Terminals_Status || (All_Payment_Terminals_Status = {}));
export var All_Payment_Terminals_ConnectionStatus;
(function (All_Payment_Terminals_ConnectionStatus) {
    All_Payment_Terminals_ConnectionStatus["ONLINE"] = "ONLINE";
    All_Payment_Terminals_ConnectionStatus["OFFLINE"] = "OFFLINE";
    All_Payment_Terminals_ConnectionStatus["CONNECTING"] = "CONNECTING";
    All_Payment_Terminals_ConnectionStatus["PROCESSING_TRANSACTION"] = "PROCESSING_TRANSACTION";
    All_Payment_Terminals_ConnectionStatus["UNKNOWN"] = "UNKNOWN";
})(All_Payment_Terminals_ConnectionStatus || (All_Payment_Terminals_ConnectionStatus = {}));
export var Payment_Terminal_ExecutionMode;
(function (Payment_Terminal_ExecutionMode) {
    Payment_Terminal_ExecutionMode["CLOUD"] = "CLOUD";
    Payment_Terminal_ExecutionMode["LOCAL_NETWORK"] = "LOCAL_NETWORK";
})(Payment_Terminal_ExecutionMode || (Payment_Terminal_ExecutionMode = {}));
export const PaymentTerminalTypeSchema = z.nativeEnum(Payment_Terminal_Type);
export const AllPaymentTerminalsStatusSchema = z.nativeEnum(All_Payment_Terminals_Status);
export const AllPaymentTerminalsConnectionStatusSchema = z.nativeEnum(All_Payment_Terminals_ConnectionStatus);
export const PaymentTerminalExecutionModeSchema = z.nativeEnum(Payment_Terminal_ExecutionMode);
